import { render, staticRenderFns } from "./MaskIcon.vue?vue&type=template&id=8972ccda&"
import script from "./MaskIcon.vue?vue&type=script&lang=js&"
export * from "./MaskIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports